import React, { useEffect, useRef, useState } from 'react'
import { Form, Accordion, Row, Col, FloatingLabel, Button, Spinner , Modal} from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { PatternFormat } from 'react-number-format';
import AmexImg from '../assets/images/amex.svg';
import VisaImg from '../assets/images/visa.svg';
import MastercardImg from '../assets/images/mastercard.svg';
import DiscoverImg from '../assets/images/discover.svg';
import CardImg from '../assets/images/card.svg';
import { checkCardType, checkCardNumberLength, checkCardDate, checkCardCVVlength } from '../utils/cardUtils';
import { callDataExchange,sendCmpiLookupRequest , verifyAuthentication} from '../utils/3D-SecureUtils';
import BillingAddress from './BillingAddress';
import { post } from '../api/transactionAPI';
import checkCardFormValidation from '../validation/cardFormValidation';
import { CardValidationError } from './ValidationError';
import CONFIGS from '../configs';



const cardImages = [
    [
        { src: AmexImg, name: 'amex' },
        { src: VisaImg, name: 'visa' },
        { src: MastercardImg, name: 'mastercard' },
        { src: DiscoverImg, name: 'discover' },
    ]
];


export default function Card({ merchantData, transactionData, is3DSecure, sendResultToParent, sendLoaderToPayment }) {

    //field validation state:
    const [nameOnCardInvalidMessage,setNameOnCardInvalidMessage] = useState('');
    const [cardNumberInvalidMessage, setCardNumberInvalidMessage] = useState('');
    const [expireDateInvalidMessage, setExpireDateInvalidMessage] = useState('');
    const [cvvInvalidMessage, setCvvInvalidMessage] = useState('');
    const [mobileNoInvalidMessage, setMobileNoInvalidMessage] = useState('');

    //form validation state:
    let errorObject = { amount: '', nameOnCard : '',cardNumber: '', expirationDate: '', cvv: '', address1: '', postalCode: '', email: '', threeDs: '' };
    const [cardFormError, setCardFormError] = useState(errorObject);
    const [cardFormValidated, setCardFormValidated] = useState(true);

    //loadning state:
    const [loading, setLoading] = useState(false);

    //card image state:
    const [cardImage, setCardImage] = useState(CardImg);

    //data object state:
    let cardObject = { nameOnCard: "", cardType: "", cardNumber: "", expirationDate: "", cvv: "", mobileNo:"" };
    const [cardData, setCardData] = useState(cardObject);
    const [isCardType, setIsCardType] = useState('');

    //catch address data state:
    const [isAddressData, setIsAddressData] = useState({});

    //create refrence for the current card details data get:
    const cardDataRef = useRef({});

    //ip address:
    const [ipAddress, setIpAddress] = useState('');

    //result state:
    let resultObject = { amount: '', cardHolderName: '',paymentType :'',customerNumber:'', invoiceNumber:'',poNumber:'',
         transaction: '', message: '', messageDetail: '', transactionId: '', approvalCode: '', avsResponse: '',transactionDate:'' };
    const [isResult, setIsResult] = useState(resultObject);

    // 3d secure otp model open:
    const [showStepUpModal, setShowStepUpModal] = useState(false);

    //agreement check:
    const [isAgreementChecked,setIsAgreementChecked] = useState(false);


    //CardNumber blur effect:
    const handleBlurOnCardNumber = () => {
        let inputCardNumber = cardData.cardNumber.trim().replace(/\s+/g, '');
        let inputCardType = cardData.cardType.trim();

        if (inputCardNumber === '') {
            setCardNumberInvalidMessage('Card Number is required');
        }

        if (inputCardNumber.length > 0 && inputCardNumber.length < 20) {
            let validLength = checkCardNumberLength(inputCardType, inputCardNumber.length);
            if (!validLength || inputCardType === 'default') {
                setCardNumberInvalidMessage('Card Number is invalid');
            }
        }
    }
    //ExpireDate blur effect:
    const handleBlurOnExpireData = () => {
        let inputExpireDate = cardData.expirationDate.trim();

        if (inputExpireDate === '') {
            setExpireDateInvalidMessage('Exp. Date is required');
        }
        if (inputExpireDate.length > 0 && inputExpireDate.length < 5) {
            setExpireDateInvalidMessage('Exp. Date is invalid');
        }
        if (inputExpireDate.length === 5) {
            const valid = checkCardDate(inputExpireDate);
            if (!valid) {
                setExpireDateInvalidMessage('Exp. Date is invalid');
            }
        }
    }
    //CVV blur effect:
    const handleBlurOnCVV = () => {
        let inputCardType = cardData.cardType.trim();
        let inputCVV = cardData.cvv.trim();

        if (inputCVV === '') {
            setCvvInvalidMessage("CVV is required");
        }
        if (inputCVV.length > 0 && inputCVV.length < 5) {
            let valid = checkCardCVVlength(inputCardType, inputCVV.length);
            if (!valid || inputCardType === 'default') {
                setCvvInvalidMessage("CVV is invalid");
            }
        }
    }

    //CardNumber blur effect:
    const handleBlurOnMobileNo = () => {
        let inputMobileNo = cardData.mobileNo ? cardData.mobileNo.replace(/\D/g, '') : '';
        
        if (inputMobileNo === '') {
            setMobileNoInvalidMessage('Mobile No is required');
        } else if (inputMobileNo.length !== 10) {
            setMobileNoInvalidMessage('Please enter a valid 10-digit mobile number');
        } else {
            setMobileNoInvalidMessage('');
        }
    };

    //name on card effect:
    const handleBlurOnNameOnCard = () =>{
        let inputNameOnCard = cardData.nameOnCard.trim();
        if(inputNameOnCard === ''){
            setNameOnCardInvalidMessage('Name on card required.')
        }
    }

    //Handle field change Input:
    const handleCardChangeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let inputCVV = cardData.cvv.trim();

        if (name === 'cardNumber') {
            setCardNumberInvalidMessage('');

            const { type, img } = checkCardType(value);
            setCardImage(img);
            setIsCardType(type);

            if (type === 'Visa' || type === 'MasterCard' || type === 'Discover' ) {
                if (inputCVV.length === 4) {
                    setCvvInvalidMessage("CVV is invalid");
                } else {
                    setCvvInvalidMessage('');
                }
            }
            if (type === 'American Express') {
                if (inputCVV.length === 3) {
                    setCvvInvalidMessage("CVV is invalid");
                } else {
                    setCvvInvalidMessage('');
                }
            }
        }
        if (name === 'expirationDate') {
            setExpireDateInvalidMessage('');
        }
        if (name === 'cvv') {
            setCvvInvalidMessage('');
        }
        if(name === 'nameOnCard'){
            setNameOnCardInvalidMessage('');
        }

        if(name === 'mobileNo'){
            setMobileNoInvalidMessage('');
        }

        setCardData({ ...cardData, [name]: value, cardType: isCardType });

    };

    //Get Address data from Billing Address component:
    const getAddressData = (data) => {
        setIsAddressData(data);
    }

    //Form Validation:
    const checkFormValidation = (field) => {  

        let errors = { ...cardFormError };
        let result = checkCardFormValidation(field, errors);
        setCardFormError(result.isErrors);
        setCardFormValidated(result.isValid);
        return result.isValid;
    }

    //PAYMENT SUBMIT:
    const paymentSubmit = async (event) => {
        try {
            event.preventDefault();

            //check agreement:
            if(!isAgreementChecked){
                alert('Please agree to the terms and conditions before proceeding.');
                return;
            }


            setIsResult(resultObject);            

            let cardPaymentData = { ...cardData, ...isAddressData, ...transactionData, ...merchantData };
            let isFormValid = checkFormValidation(cardPaymentData);

            // This information for success page after payment completed.
            let customerPaymentInformation = {
                amount: cardPaymentData.amount,
                cardHolderName: cardPaymentData.nameOnCard,
                paymentType : cardPaymentData.cardType ?? 'default',
                customerNumber : cardPaymentData.cardNumber,
            }
            if(cardPaymentData && cardPaymentData.invoiceNumber){
                customerPaymentInformation = {...customerPaymentInformation, invoiceNumber : cardPaymentData.invoiceNumber};
            }
            if(cardPaymentData && cardPaymentData.poNumber){
                customerPaymentInformation = {...customerPaymentInformation, poNumber: cardPaymentData.poNumber };
            }

            if (isFormValid) {
                setLoading(true);
            
                if(is3DSecure){
                    // 3D-Secure verification:
                    await callDataExchange(cardPaymentData.cardNumber);
                    return ;
                } else {
                    
                    let result = await post(cardPaymentData, 'card');
                    setLoading(false);
                    
                    if (result?.ResponseCode === "00") {
                        
                        setIsResult({
                            ...customerPaymentInformation,
                            transaction: 'Approved',
                            approvalCode: result?.ApprovalCode ?? '',
                            avsResponse : result?.AvsResponse ?? '',
                            transactionId: result?.TransactionID ? String(result.TransactionID) : '',
                            transactionDate: result?.TransactionDate ?? ''
                        });
                        return;
                    
                    } else {
                        
                        setIsResult({
                            ...customerPaymentInformation,
                            transaction: 'Failed',
                            message: result?.ResponseMessage ?? '',
                            messageDetail: result?.ResponseMessageDetail ?? 'Transaction could not be processed',
                            avsResponse : result?.AvsResponse ?? '',
                            transactionId: result?.TransactionID ? String(result.TransactionID) : '',
                            transactionDate: result?.TransactionDate ?? ''
                        });
                        return;
                    }
                }
            }
        } catch (error) {
            setLoading(false);
            setIsResult({ transaction: 'Failed', error: true });
            return;
        }
    }

    //send success transaction result to parent:
    useEffect(() => {
        sendResultToParent(isResult);
    }, [isResult, sendResultToParent]);

    // 2. useEffect to ref.current data
    useEffect(() => {
        cardDataRef.current = { ...cardData, ...isAddressData, ...transactionData,...merchantData,ipAddress};
    }, [cardData, isAddressData,transactionData,merchantData,ipAddress]);
    
    // send loader effect to payment component:
    useEffect(() => {
        sendLoaderToPayment(loading);
    },[loading,sendLoaderToPayment]);

    //get ip-address
    useEffect(() => {
        const fetchIp = async () =>{
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            setIpAddress(data.ip);
        }
        fetchIp();
    }, []);

    //3D-secure event listner:
    useEffect(()=>{
        const handle3dSecureDataResponse = async (event) =>{
            if(event.origin !== CONFIGS.API.CARDINAL_SERVICE){
                return;
            }

            try {
                let data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
                // console.log('Merchant received a message:', data);
                
                if (data && typeof data !== "undefined") {
                    if (data?.Payload && data.Payload?.ActionCode === "SUCCESS") {
                        // console.log(JSON.stringify(data));

                        if (data.MessageType && data.MessageType === 'stepUp.acsRedirection') {
                            // console.log("stepUp.acsRedirection");
                        } else {
                            const extractedSessionId = data.Payload?.SessionId;
                            
                            if (extractedSessionId) {
                                // console.log("session  data ->",extractedSessionId,new URL(window.location.href))

                               let lookUpResult = await sendCmpiLookupRequest({ ...cardDataRef.current,sessionId: extractedSessionId,currentUrl: new URL(window.location.href).href },() => {
                                    setShowStepUpModal(true);
                                });


                                if(lookUpResult && lookUpResult?.success){

                                    let lookUpData = {
                                        'xid' : lookUpResult.xid,
                                        'threeDSServerTransactionId' : lookUpResult.parsedResponse.ThreeDSServerTransactionId || '',
                                        'cavv' : lookUpResult.parsedResponse.Cavv || '',
                                        'eciFlag' : lookUpResult.parsedResponse.EciFlag || '',
                                        'is3DSecure' : true
                                    }

                                    let cardPaymentData = {...cardDataRef.current, ...lookUpData };
                                    
                                    let customerPaymentInformation = {
                                        amount: cardPaymentData.amount,
                                        cardHolderName: cardPaymentData.nameOnCard,
                                        paymentType : cardPaymentData.cardType ?? 'default',
                                        customerNumber : cardPaymentData.cardNumber
                                    }
                                    if(cardPaymentData && cardPaymentData.invoiceNumber){
                                        customerPaymentInformation = {...customerPaymentInformation, invoiceNumber : cardPaymentData.invoiceNumber};
                                    }
                                    if(cardPaymentData && cardPaymentData.poNumber){
                                        customerPaymentInformation = {...customerPaymentInformation, poNumber: cardPaymentData.poNumber };
                                    }
                                    
                                    let result = await post(cardPaymentData, 'card');
                                    setLoading(false);
                                    
                                    if (result?.ResponseCode === "00") {
                                        setIsResult({
                                            ...customerPaymentInformation,
                                            transaction: 'Approved',
                                            approvalCode: result?.ApprovalCode ?? '',
                                            avsResponse : result?.AvsResponse ?? '',
                                            transactionId: result?.TransactionID ? String(result.TransactionID) : '',
                                            transactionDate: result?.TransactionDate ?? ''
                                        });
                                        return;
                                    } else {
                                        setIsResult({
                                            ...customerPaymentInformation,
                                            transaction: 'Failed',
                                            message: result?.ResponseMessage ?? '',
                                            messageDetail: result?.ResponseMessageDetail ?? 'Transaction could not be processed',
                                            avsResponse : result?.AvsResponse ?? '',
                                            transactionId: result?.TransactionID ? String(result.TransactionID) : '',
                                            transactionDate: result?.TransactionDate ?? ''
                                        });
                                        return;
                                    }
                                } else if(lookUpResult && lookUpResult?.success === false){
                                    //Card Not Enrolled in EMV 3DS
                                    setCardFormError({...errorObject,threeDs : 'This card cannot be verified. Please try using a different credit card.'});
                                    setLoading(false);
                                    return;
                                }
                            }
                        }
                    } else {
                        // Perform appropriate action if ActionCode is not successfully.
                        // console.log("ActionCode is not SUCCESS");
                    }
                }
            } catch (error) {
                setLoading(false);
                setIsResult({ transaction: 'Failed', error: true });
                return;
            }
        };

        window.addEventListener("message",handle3dSecureDataResponse,false);
        
        // Cleanup function (when Component unmount listener remove)
        return () => {
            window.removeEventListener("message", handle3dSecureDataResponse, false);
        };
    },[]);

    //3d-secure authenticater event:
    useEffect(() => {
        const handleAuthMessage = async (event) => {
            const allowedOrigins = ["cardinalcommerce.com", "securepay.net", window.location.origin];
            
            const isAllowed = allowedOrigins.some(origin => event.origin.includes(origin));

            if (event.data?.TransactionId || event.data?.transactionId) {

                const transactionId = event.data?.TransactionId || event.data?.transactionId;

                if (transactionId) {
                    try {
                        setShowStepUpModal(false);
                        let authLookUpResult = await verifyAuthentication(transactionId);
                        
                        if(authLookUpResult && authLookUpResult?.success){
                            
                            let authLookUpData = {
                                'xid' : authLookUpResult.xid,
                                'threeDSServerTransactionId' : authLookUpResult.threeDSServerTransactionId || '',
                                'cavv' : authLookUpResult.cavv || '',
                                'eciFlag' : authLookUpResult.eciFlag || '',
                                'is3DSecure' : true
                            }
                            
                            let cardPaymentData = {...cardDataRef.current, ...authLookUpData };
                            
                            let customerPaymentInformation = {
                                amount: cardPaymentData.amount,
                                cardHolderName: cardPaymentData.nameOnCard,
                                paymentType : cardPaymentData.cardType ?? 'default',
                                customerNumber : cardPaymentData.cardNumber
                            }
                            
                            if(cardPaymentData && cardPaymentData.invoiceNumber){
                                customerPaymentInformation = {...customerPaymentInformation, invoiceNumber : cardPaymentData.invoiceNumber};
                            }
                            if(cardPaymentData && cardPaymentData.poNumber){
                                customerPaymentInformation = {...customerPaymentInformation, poNumber: cardPaymentData.poNumber };
                            }
                            
                            let result = await post(cardPaymentData, 'card');
                            setLoading(false);
                            
                            if (result?.ResponseCode === "00") {
                                
                                setIsResult({
                                    ...customerPaymentInformation,
                                    transaction: 'Approved',
                                    approvalCode: result?.ApprovalCode ?? '',
                                    avsResponse : result?.AvsResponse ?? '',
                                    transactionId: result?.TransactionID ? String(result.TransactionID) : '',
                                    transactionDate: result?.TransactionDate ?? ''
                                });
                                return;
                            
                            } else {
                                
                                setIsResult({
                                    ...customerPaymentInformation,
                                    transaction: 'Failed',
                                    message: result?.ResponseMessage ?? '',
                                    messageDetail: result?.ResponseMessageDetail ?? 'Transaction could not be processed',
                                    avsResponse : result?.AvsResponse ?? '',
                                    transactionId: result?.TransactionID ? String(result.TransactionID) : '',
                                    transactionDate: result?.TransactionDate ?? ''
                                });
                                return;
                            }
                        } else if(authLookUpResult && authLookUpResult?.success === false){
                            setCardFormError({...errorObject,threeDs : 'This card cannot be verified. Please try using a different credit card.'});
                            setLoading(false);
                            return;
                        }
                    } catch (error) {
                        setLoading(false);
                        setIsResult({ transaction: 'Failed', error: true });
                        return;
                    }
                }
            }
        };
        
        window.addEventListener("message", handleAuthMessage);
        return () => window.removeEventListener("message", handleAuthMessage);
    }, []);

    return (
        <>
            <Accordion.Header>

                <div className="accordion-headline">
                    <strong className="accordion-title d-block">Card</strong>
                    <span className="accordion-subtitle">Debit and Credit accepted.</span>
                </div>
                <div className="accordion-images d-none d-md-block">
                    {cardImages.map((imageGroup, index) => (
                        <ul className="cardimageList" key={index}>
                            {imageGroup.map((image, imgIndex) => (
                                <li key={imgIndex}>
                                    <img src={image.src} alt={`${image.name}`} />
                                </li>
                            ))}
                        </ul>
                    ))}
                </div>
            </Accordion.Header>
            <Accordion.Body>
                <Form onSubmit={paymentSubmit}>
                    <Row>
                        <Form.Group as={Col} xl={6} controlId="floatingNameonCard">
                            <FloatingLabel controlId="floatingNameonCard" label={<span className={nameOnCardInvalidMessage ? 'text-danger' : ''}>
                                {nameOnCardInvalidMessage ? nameOnCardInvalidMessage : "Name on Card"}</span>} className="mb-2">
                                <Form.Control 
                                type="text" 
                                placeholder="Name on Card" 
                                name="nameOnCard"
                                className={`form-control ${nameOnCardInvalidMessage ? 'border-danger' : ''}`} 
                                value={cardData.nameOnCard} 
                                disabled={loading}
                                onBlur={handleBlurOnNameOnCard}
                                onChange={handleCardChangeInput} />
                            </FloatingLabel>
                        </Form.Group>
                        
                        <Form.Group as={Col} xl={6} controlId="floatingMobileNumber">
                            <FloatingLabel controlId="floatingMobileNumber"
                                label={
                                    <span className={mobileNoInvalidMessage ? 'text-danger' : ''}>
                                        {mobileNoInvalidMessage ? mobileNoInvalidMessage : "Mobile No."}
                                    </span>
                                }
                                className="mb-2">
                                <PatternFormat
                                    format="(###) ###-####"
                                    mask=""
                                    id="floatingMobileNumber"
                                    className={`form-control ${mobileNoInvalidMessage ? 'border-danger' : ''}`}
                                    placeholder="Mobile no."
                                    name="mobileNo"
                                    value={cardData.mobileNo}
                                    disabled={loading}
                                    onBlur={handleBlurOnMobileNo}
                                    onChange={handleCardChangeInput}
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                    <Row className="gx-2">

                        <Form.Group as={Col} xl={6} controlId="floatingCardNumber">
                            <FloatingLabel controlId="floatingCardNumber"
                                label={
                                    <span className={cardNumberInvalidMessage ? 'text-danger' : ''}>
                                        {cardNumberInvalidMessage ? cardNumberInvalidMessage : "Card Number"}
                                    </span>
                                }
                                className="mb-2">
                                <img src={cardImage} alt="Card" className="card-icon" />
                                <PatternFormat
                                    format={cardData.cardType === 'default' ? "################" : ( cardData.cardType === 'American Express' ? "#### ###### #####" : "#### #### #### ####")}
                                    mask=""
                                    id="floatingCardNumber"
                                    className={`form-control ${cardNumberInvalidMessage ? 'border-danger' : ''}`}
                                    placeholder="Card Number"
                                    name="cardNumber"
                                    value={cardData.cardNumber}
                                    disabled={loading}
                                    onBlur={handleBlurOnCardNumber}
                                    onChange={handleCardChangeInput}
                                />
                            </FloatingLabel>
                        </Form.Group>

                        <Form.Group as={Col} xl={3} xs={6} controlId="floatingExpdate">
                            <FloatingLabel controlId="floatingExpdate"
                                label={
                                    <span className={expireDateInvalidMessage ? 'text-danger' : ''}>
                                        {expireDateInvalidMessage ? expireDateInvalidMessage : "Exp. Date"}
                                    </span>
                                }
                                className="mb-2">
                                <PatternFormat
                                    format="##/##"
                                    mask=""
                                    id="floatingExpdate"
                                    className={`form-control ${expireDateInvalidMessage ? 'border-danger' : ''}`}
                                    placeholder="Exp. Date"
                                    name="expirationDate"
                                    value={cardData.expirationDate}
                                    disabled={loading}
                                    onBlur={handleBlurOnExpireData}
                                    onChange={handleCardChangeInput}
                                />
                            </FloatingLabel>
                        </Form.Group>

                        <Form.Group as={Col} xl={3} xs={6} controlId="floatingCVV">
                            <FloatingLabel controlId="floatingCVV"
                                label={
                                    <span className={cvvInvalidMessage ? 'text-danger' : ''}>
                                        {cvvInvalidMessage ? cvvInvalidMessage : "CVV"}
                                    </span>
                                }
                                className="mb-2"> 
                                <PatternFormat
                                    format={cardData.cardType === 'American Express' ? "####" : (cardData.cvv.length === 4 ? '####' : '###')}
                                    type="password"
                                    mask=""
                                    id="floatingCVV"
                                    className={`form-control ${cvvInvalidMessage ? 'border-danger' : ''}`}
                                    placeholder="CVV"
                                    name="cvv"
                                    value={cardData.cvv}
                                    disabled={loading}
                                    onBlur={handleBlurOnCVV}
                                    onChange={handleCardChangeInput}
                                    minLength="3"
                                    autoComplete='cc-csc'                                    
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Row>

                    <BillingAddress uniqueId="1" sendAddressDataToParent={getAddressData} isLoaderRunning={loading} />

                    {/* <Row className="mt-2 mb-3">
                        <Col xs={6}>
                            <div className="payment-label">Payment</div>
                        </Col>
                        <Col xs={6} className="text-end">
                            <div className="payment-value">${transactionData.amount ? transactionData.amount : "0.00"}</div>
                        </Col>
                    </Row> */}

                    {/* print form validation error message here */}
                    {(!cardFormValidated || cardFormError.threeDs ) && <CardValidationError cardFormError={cardFormError} />}
                    
                    {/* <Row className="mt-3">
                        <Col className="payment-disclaimer">
                            <p>By clicking on the Pay Button, you agree to pay the above amount and provide your information to help us process your payment and detect fraud. Please see our <a href="https://securepay.com/privacy.html" rel="noopener noreferrer" target="_blank">Privacy Policy</a> for more information on our data practices.</p>
                        </Col>
                    </Row> */}
                    
                    <Row className="mt-3">
                        <Col className="payment-disclaimer">
                        <div className="form-check mb-2 d-flex align-items-start">
                            <input 
                            className="form-check-input me-2"
                            type="checkbox" id="agreeCheckbox"
                            checked={isAgreementChecked}
                            onChange={(e) => setIsAgreementChecked(e.target.checked)}
                            style={{ width: '0.86rem', height: '0.86rem' }} 
                            required 
                            />
                            <label className="form-check-label text-dark" htmlFor="agreeCheckbox" style={{ fontSize: '0.86rem', fontStyle: 'normal' }}>
                                By clicking on the Pay Button, you agree to pay the above amount and provide your information to help us process your payment and detect fraud. Please see our <a href="https://securepay.com/privacy.html" rel="noopener noreferrer" target="_blank">Privacy Policy</a> for more information on our data practices.
                            </label>
                        </div>
                    </Col>
                </Row>


                    <Row className="mt-2 mb-2">
                        <Col className="text-end">
                            <Button type="submit" className="payment-button" variant="primary" disabled={loading}>
                                {loading ? (
                                    <>
                                        <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                                        {' '}Processing...
                                    </>
                                ) : (
                                    `Pay $${transactionData.amount ? transactionData.amount : "0.00"}`
                                )}
                            </Button>
                        </Col>
                    </Row>

                </Form>

                {/* ********************** 3D-Secure Device Data Collection Iframe ********************* */}
                <iframe id="iframeJWTFrm" name="iframeJWTFrm" height="10" width="10"></iframe>
                
                
                {/* Otp frame open */}
                <Modal show={showStepUpModal}  onHide={() => setShowStepUpModal(false)} backdrop="static" keyboard={false} centered size="lg" >
                    <Modal.Body className="text-center">
                        <iframe scrolling="no" name="stepupiFrame" id="stepupiFrame" style={{ width: '100%', height: '720px', border: 'none' }}></iframe>
                    </Modal.Body>
                </Modal>
            </Accordion.Body>

        </>
    )
}